"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var video_origin_1 = require("../../../../common/ui-selectors/video/video-origin");
var select_1 = tslib_1.__importDefault(require("../../../ui-components/select/select"));
var content_1 = require("./utils/content");
var title_1 = tslib_1.__importDefault(require("./title/title"));
var facebook_1 = tslib_1.__importDefault(require("./facebook/facebook"));
var twitter_1 = tslib_1.__importDefault(require("./twitter/twitter"));
var pinterest_1 = tslib_1.__importDefault(require("./pinterest/pinterest"));
var tumblr_1 = tslib_1.__importDefault(require("./tumblr/tumblr"));
var link_1 = tslib_1.__importStar(require("./link/link"));
var embed_button_1 = tslib_1.__importDefault(require("./embed-button/embed-button"));
var more_1 = tslib_1.__importDefault(require("./more/more"));
var constants_1 = require("./constants");
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var HIDE_MESSAGE_TIMEOUT = 3000;
var stopPropagation = function (e) {
    e.stopPropagation();
};
var ShareButtons = /** @class */ (function (_super) {
    tslib_1.__extends(ShareButtons, _super);
    function ShareButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.setState({
                shareMode: event.target.value,
            });
        };
        _this.handleLinkClick = function () {
            var showLinkCopied = _this.state.showLinkCopied;
            // do not allow to copy link during next 3 sec after first attempt
            if (showLinkCopied) {
                return;
            }
            _this.setState({ showLinkCopied: true });
            setTimeout(function () {
                _this.setState({ showLinkCopied: false });
            }, HIDE_MESSAGE_TIMEOUT);
            _this.props.onLinkCopied({
                shareType: _this.isInShareChannelMode()
                    ? constants_1.SHARE_MODES.CHANNEL
                    : constants_1.SHARE_MODES.VIDEO,
            });
        };
        _this.handleEmbedClick = function () {
            _this.props.onEmbedClicked({
                shareType: _this.isInShareChannelMode()
                    ? constants_1.SHARE_MODES.CHANNEL
                    : constants_1.SHARE_MODES.VIDEO,
            });
        };
        _this.handleShare = function (networkName) {
            _this.props.onShare({
                networkName: networkName,
                shareType: _this.isInShareChannelMode()
                    ? constants_1.SHARE_MODES.CHANNEL
                    : constants_1.SHARE_MODES.VIDEO,
            });
        };
        _this.state = {
            shareMode: props.shareMode,
            showLinkCopied: false,
        };
        return _this;
    }
    ShareButtons.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var shareMode = this.props.shareMode;
        if (nextProps.shareMode !== shareMode) {
            this.setState({ shareMode: nextProps.shareMode });
        }
    };
    ShareButtons.prototype.isInShareChannelMode = function () {
        return this.state.shareMode === constants_1.SHARE_MODES.CHANNEL;
    };
    ShareButtons.prototype.isEmbedButtonHidden = function () {
        var videoItem = this.props.videoItem;
        return this.isInShareChannelMode() || (0, video_origin_1.isExternalVideo)(videoItem);
    };
    ShareButtons.prototype.getShareOptions = function () {
        var _a = this.props, shareChannelText = _a.shareChannelText, shareVideoText = _a.shareVideoText;
        return [
            {
                value: constants_1.SHARE_MODES.CHANNEL,
                text: shareChannelText,
            },
            {
                value: constants_1.SHARE_MODES.VIDEO,
                text: shareVideoText,
            },
        ];
    };
    ShareButtons.prototype.getContentToShare = function () {
        if (this.isInShareChannelMode()) {
            var channelData = this.props.channelData;
            return (0, content_1.getChannelContent)(channelData);
        }
        else {
            var videoItem = this.props.videoItem;
            return (0, content_1.getVideoContent)(videoItem);
        }
    };
    ShareButtons.prototype.getInstanceInfo = function () {
        var _a = this.props, channelUrl = _a.channelUrl, videoUrl = _a.videoUrl, instanceInfo = _a.instanceInfo;
        return tslib_1.__assign(tslib_1.__assign({}, instanceInfo), { siteUrl: this.isInShareChannelMode() ? channelUrl : videoUrl });
    };
    ShareButtons.prototype.shouldShowEmbedButton = function () {
        var shouldShowEmbedButton = this.props.shouldShowEmbedButton;
        return shouldShowEmbedButton && !this.isEmbedButtonHidden();
    };
    ShareButtons.prototype.render = function () {
        var _a = this.props, titleText = _a.titleText, children = _a.children, channelData = _a.channelData, videoItem = _a.videoItem, onMoreClicked = _a.onMoreClicked, facebookAriaLabel = _a.facebookAriaLabel, twitterAriaLabel = _a.twitterAriaLabel, pinterestAriaLabel = _a.pinterestAriaLabel, tumblrAriaLabel = _a.tumblrAriaLabel, linkAriaLabel = _a.linkAriaLabel, embedAriaLabel = _a.embedAriaLabel, moreAriaLabel = _a.moreAriaLabel, embedTooltipText = _a.embedTooltipText, facebookTooltipText = _a.facebookTooltipText, linkTooltipText = _a.linkTooltipText, moreTooltipText = _a.moreTooltipText, pinterestTooltipText = _a.pinterestTooltipText, tumblrTooltipText = _a.tumblrTooltipText, twitterTooltipText = _a.twitterTooltipText, canShareContent = _a.canShareContent, canShowSelect = _a.canShowSelect, shouldShowFacebookButton = _a.shouldShowFacebookButton, shouldShowTwitterButton = _a.shouldShowTwitterButton, shouldShowPinterestButton = _a.shouldShowPinterestButton, shouldShowTumblrButton = _a.shouldShowTumblrButton, shouldShowLinkButton = _a.shouldShowLinkButton, shouldShowMoreButton = _a.shouldShowMoreButton, isRTL = _a.isRTL, twitterDescriptionText = _a.twitterDescriptionText, pinterestDescriptionText = _a.pinterestDescriptionText, tumblrDescriptionText = _a.tumblrDescriptionText, linkCopiedText = _a.linkCopiedText;
        if (children) {
            return children;
        }
        var _b = this.state, shareMode = _b.shareMode, showLinkCopied = _b.showLinkCopied;
        var videoId = this.isInShareChannelMode() ? null : videoItem.id;
        var channelId = channelData.id;
        var contentToShare = this.getContentToShare();
        var instanceInfo = this.getInstanceInfo();
        return (react_1.default.createElement("section", { className: styles_scss_1.default.container, onClick: stopPropagation },
            react_1.default.createElement(title_1.default, { text: titleText, dataHook: "title" }),
            canShowSelect && (react_1.default.createElement(select_1.default, { dataHook: "share-select", className: styles_scss_1.default.select, options: this.getShareOptions(), selected: shareMode, onChange: this.handleChange, isRTL: isRTL })),
            react_1.default.createElement("div", { "data-hook": "share-buttons", className: styles_scss_1.default['share-buttons'] },
                shouldShowFacebookButton && (react_1.default.createElement(facebook_1.default, { canShareContent: canShareContent, dataHook: "facebook", tooltip: facebookTooltipText, onShare: this.handleShare, videoId: videoId, channelId: channelId, content: contentToShare, instanceInfo: instanceInfo, ariaLabel: facebookAriaLabel })),
                shouldShowTwitterButton && (react_1.default.createElement(twitter_1.default, { canShareContent: canShareContent, dataHook: "twitter", tooltip: twitterTooltipText, onShare: this.handleShare, descriptionText: twitterDescriptionText, videoId: videoId, channelId: channelId, content: contentToShare, instanceInfo: instanceInfo, ariaLabel: twitterAriaLabel })),
                shouldShowPinterestButton && (react_1.default.createElement(pinterest_1.default, { canShareContent: canShareContent, dataHook: "pinterest", tooltip: pinterestTooltipText, onShare: this.handleShare, content: contentToShare, instanceInfo: instanceInfo, descriptionText: pinterestDescriptionText, ariaLabel: pinterestAriaLabel })),
                shouldShowTumblrButton && (react_1.default.createElement(tumblr_1.default, { canShareContent: canShareContent, className: styles_scss_1.default.tumblr, dataHook: "tumblr", tooltip: tumblrTooltipText, onShare: this.handleShare, content: contentToShare, instanceInfo: instanceInfo, descriptionText: tumblrDescriptionText, ariaLabel: tumblrAriaLabel })),
                shouldShowLinkButton && (react_1.default.createElement(link_1.default, { canShareContent: canShareContent, dataHook: "link", onClick: this.handleLinkClick, tooltip: linkTooltipText, instanceInfo: instanceInfo, ariaLabel: linkAriaLabel })),
                this.shouldShowEmbedButton() && (react_1.default.createElement(embed_button_1.default, { dataHook: "embed-button", onClick: this.handleEmbedClick, tooltip: embedTooltipText, ariaLabel: embedAriaLabel })),
                shouldShowMoreButton && (react_1.default.createElement(more_1.default, { dataHook: "more-button", onClick: onMoreClicked, tooltip: moreTooltipText, ariaLabel: moreAriaLabel }))),
            canShareContent && (react_1.default.createElement(link_1.LinkCopied, { dataHook: "link-copied", shouldShowLink: showLinkCopied, text: linkCopiedText, isRTL: isRTL }))));
    };
    ShareButtons.propTypes = {
        shareMode: prop_types_1.default.oneOf([constants_1.SHARE_MODES.VIDEO, constants_1.SHARE_MODES.CHANNEL]),
        titleText: prop_types_1.default.string.isRequired,
        children: prop_types_1.default.node,
        channelData: prop_types_1.default.object,
        videoItem: prop_types_1.default.object,
        instanceInfo: prop_types_1.default.object,
        videoUrl: prop_types_1.default.string,
        channelUrl: prop_types_1.default.string,
        canShareContent: prop_types_1.default.bool,
        canShowSelect: prop_types_1.default.bool,
        shouldShowFacebookButton: prop_types_1.default.bool,
        shouldShowTwitterButton: prop_types_1.default.bool,
        shouldShowPinterestButton: prop_types_1.default.bool,
        shouldShowTumblrButton: prop_types_1.default.bool,
        shouldShowLinkButton: prop_types_1.default.bool,
        shouldShowEmbedButton: prop_types_1.default.bool,
        shouldShowMoreButton: prop_types_1.default.bool,
        isRTL: prop_types_1.default.bool,
        shareChannelText: prop_types_1.default.string,
        shareVideoText: prop_types_1.default.string,
        twitterDescriptionText: prop_types_1.default.string,
        pinterestDescriptionText: prop_types_1.default.string,
        tumblrDescriptionText: prop_types_1.default.string,
        linkCopiedText: prop_types_1.default.string,
        // aria labels
        facebookAriaLabel: prop_types_1.default.string,
        twitterAriaLabel: prop_types_1.default.string,
        pinterestAriaLabel: prop_types_1.default.string,
        tumblrAriaLabel: prop_types_1.default.string,
        linkAriaLabel: prop_types_1.default.string,
        embedAriaLabel: prop_types_1.default.string,
        moreAriaLabel: prop_types_1.default.string,
        // tooltips
        embedTooltipText: prop_types_1.default.string,
        facebookTooltipText: prop_types_1.default.string,
        linkTooltipText: prop_types_1.default.string,
        moreTooltipText: prop_types_1.default.string,
        pinterestTooltipText: prop_types_1.default.string,
        tumblrTooltipText: prop_types_1.default.string,
        twitterTooltipText: prop_types_1.default.string,
        // callbacks
        onShare: prop_types_1.default.func,
        onEmbedClicked: prop_types_1.default.func,
        onMoreClicked: prop_types_1.default.func,
        onLinkCopied: prop_types_1.default.func,
    };
    ShareButtons.defaultProps = {
        canShareContent: true,
        canShowSelect: true,
        shouldShowFacebookButton: true,
        shouldShowTwitterButton: true,
        shouldShowPinterestButton: true,
        shouldShowTumblrButton: true,
        shouldShowLinkButton: true,
        shouldShowEmbedButton: false,
        shouldShowMoreButton: false,
        twitterDescriptionText: '',
        pinterestDescriptionText: '',
        shareMode: constants_1.SHARE_MODES.CHANNEL,
        onShare: lodash_1.noop,
        onEmbedClicked: lodash_1.noop,
        onMoreClicked: lodash_1.noop,
        onLinkCopied: lodash_1.noop,
    };
    return ShareButtons;
}(react_1.default.Component));
exports.default = ShareButtons;
//# sourceMappingURL=share-buttons.js.map